package com.milta.core.localization.translations.es

import com.milta.core.localization.AuthStrings

internal val Auth = AuthStrings(
    login = "Iniciar sesión",
    logout = "Cerrar sesión",
    email = "Email",
    password = "Contraseña",
    showPassword = "Mostrar",
    hidePassword = "Ocultar",
    roleSelectionTitle = "Crear una cuenta",
    roleSelectionSubtitle = "Elige el tipo de cuenta que corresponde a tu perfil",
    roleDriverTitle = "Soy conductor - repartidor",
    roleDriverDescription = "Conduzco un vehículo de transporte o reparto y quiero optimizar mis rutas",
    roleDriverTag1 = "Optimizar mis rutas",
    roleDriverTag2 = "Ofertas Milta en mi ruta",
    roleEnterpriseTitle = "Soy una empresa",
    roleEnterpriseDescription = "Tengo un número de IVA y gestiono una flota de vehículos y un equipo de conductores",
    roleEnterpriseTag1 = "Gestión de flota",
    roleEnterpriseTag2 = "Seguimiento de equipos",
    continueButton = "Continuar",
    registerFormTitle = "Completa tu registro",
    registerFormSubtitle = "Confirma tu número de teléfono para activar tu cuenta.",
    registerFormSubtitleEnterprise = "Introduce tu organización y un número de teléfono para activar tu cuenta.",
    googleAccountConnected = "Cuenta de Google conectada",
    appleAccountConnected = "Cuenta de Apple conectada",
    firstName = "Nombre",
    lastName = "Apellido",
    phoneNumber = "Número de teléfono",
    phoneNumberHelper = "Introduce el número de teléfono que prefieras.",
    phoneNumberOtpInfo = "Se enviará un código de verificación por SMS para confirmar este número.",
    registerButton = "Recibir un código de verificación",
    passwordHint = "Al menos 8 caracteres",
    registerSuccess = "Cuenta creada con éxito",
    errorEmailConflict = "Esta dirección de email ya está en uso",
    errorPhoneConflict = "Este número de teléfono ya está registrado",
    errorGeneric = "Conexión fallida. Comprueba tu red e inténtalo de nuevo.",
    errorFirstNameRequired = "Por favor, introduce tu nombre",
    errorFirstNameTooLong = "El nombre no puede superar los 100 caracteres",
    errorLastNameRequired = "Por favor, introduce tu apellido",
    errorLastNameTooLong = "El apellido no puede superar los 100 caracteres",
    errorPhoneTooLong = "El número de teléfono no puede superar los 20 caracteres",
    errorOAuthAccountExists = "Esta cuenta ya está vinculada a otra cuenta de Milta. Intenta iniciar sesión.",
    errorOAuthTokenInvalid = "Tu sesión ha caducado. Vuelve a iniciar sesión.",
    loginTitle = "Iniciar sesión",
    loginTabPassword = "Contraseña",
    loginTabPhone = "Teléfono",
    loginButton = "Iniciar sesión",
    forgotPassword = "¿Olvidaste tu contraseña?",
    sendCodeButton = "Enviar código",
    otpTitle = "Ingresa el código",
    otpSubtitle = "Enviamos un código de 6 dígitos al",
    otpVerifyButton = "Verificar",
    otpResend = "Reenviar código",
    otpResendPrefix = "¿No recibiste el código?",
    otpWrongNumber = "¿Número incorrecto?",
    otpModifyLink = "Modificar",
    forgotPasswordTitle = "Contraseña olvidada",
    forgotPasswordSubtitle = "Introduce tu email para recibir un enlace de restablecimiento",
    forgotPasswordButton = "Enviar enlace",
    forgotPasswordSuccess = "Revisa tu bandeja de entrada",
    resetPasswordTitle = "Nueva contraseña",
    resetPasswordSubtitle = "Elige una nueva contraseña para tu cuenta",
    resetPasswordNewLabel = "Nueva contraseña",
    resetPasswordConfirmLabel = "Confirmar contraseña",
    resetPasswordButton = "Restablecer contraseña",
    resetPasswordSuccess = "Contraseña restablecida. Ahora puedes iniciar sesión.",
    errorPasswordTooShort = "La contraseña debe tener al menos 8 caracteres",
    errorPasswordTooLong = "La contraseña no puede superar los 128 caracteres",
    errorPasswordMismatch = "Las contraseñas no coinciden",
    errorTokenInvalid = "Este enlace de restablecimiento no es válido o ha caducado. Solicita uno nuevo.",
    errorEmailInvalid = "Por favor introduce un correo electronico valido",
    errorPhoneRequired = "Por favor introduce un numero de telefono",
    errorInvalidCredentials = "Email o contraseña incorrectos. Usa '¿Olvidaste tu contraseña?' si es necesario.",
    errorInvalidOtp = "Código incorrecto. Comprueba tu SMS o solicita uno nuevo.",
    errorExpiredOtp = "Código caducado. Solicita uno nuevo.",
    errorTooManyAttempts = "Demasiados intentos fallidos. Inténtalo de nuevo en unos minutos.",
    errorResendLimit = "Demasiadas solicitudes de reenvío. Inténtalo en unos minutos.",
    otpResendIn = "Reenviar en %d s",
    otpAttemptsLeft = "Te quedan %d intentos",
    loginGreeting = "¡Bienvenido de nuevo!",
    loginSubtitle = "Inicia sesión en tu cuenta Milta",
    loginSmsOption = "Recibir un código SMS",
    noAccount = "¿Aún no tienes cuenta?",
    signUp = "Registrarse",
    organizationName = "Nombre de la organización",
    organizationNameRequired = "Por favor, ingrese el nombre de la organización",
    registerNextButton = "Siguiente",
    passwordConfirm = "Confirmar contraseña",
    passwordRuleUpper = "Una letra mayúscula",
    passwordRuleDigit = "Un dígito",
    passwordRuleSpecial = "Un carácter especial",
    alreadyHaveAccount = "¿Ya tienes cuenta? — Iniciar sesión",
)
